// English translation
export default {
  app: { name: 'Pengji', slogan: 'Only for those truly close', loading: 'Loading...' },
  nav: { circles: 'Circles', chats: 'Chats', friends: 'Friends', me: 'Me', federal: 'Federation' },
  home: {
    welcome: 'Welcome to Pengji',
    myCircles: 'My Circles',
    recentMessages: 'Recent Messages',
    noMessages: 'No messages yet',
    noCircles: 'Create your first circle, invite those closest to you',
    createCircle: 'Create Circle',
    quickActions: { groupChat: 'Group Chat', moments: 'Moments', lists: 'Lists', polls: 'Polls' },
    members: 'members',
    crossCirclePeople: 'Cross-Circle People',
    digitalHealth: 'Digital Health',
  },
  digitalHealth: {
    title: 'Digital Health',
    today: 'Today',
    thisWeek: 'This Week',
    focusMode: 'Deep Focus Mode',
    focusModeDesc: 'Lock app on schedule, block non-urgent notifications',
    startFocus: 'Start Focus',
    stopFocus: 'End Focus',
    dailyLimit: 'Daily Usage Limit',
    unlimited: 'Unlimited',
    toolPhilosophy: 'Pengji is a tool, not a destination. Use it, then return to real life.',
    minutes: 'min',
  },
  safetyNumber: {
    title: 'Verify Safety Number',
    description: 'Compare safety numbers to prevent MITM attacks',
    verified: 'Verified',
    keyChanged: 'Key Changed',
    step1: 'Copy the safety number, send it to the other person via a secure channel',
    step2: 'Ask them to check their safety number on their device',
    step3: 'Compare both numbers to verify they match',
    match: 'Numbers Match',
    notMatch: 'Not Match',
    verifiedMessage: 'Identity verified, communication is end-to-end encrypted',
    techDetail: 'Safety number is derived from public key hash, similar to Signal verification',
  },
  widgetPrivacy: {
    hidden: 'Fully Hidden',
    blurred: 'Blurred',
    normal: 'Normal',
    unlockPrompt: 'Tap to unlock and view',
    bioAuth: 'Biometric verification required',
    tapToUnlock: 'Tap to unlock with biometrics',
    unlocked: 'Unlocked',
    autoLock: 'Content will auto-lock after 30 seconds',
    lock: 'Lock',
    localOnly: 'Biometric data is stored only on device, never uploaded',
  },
  wechatImport: {
    title: 'WeChat Chat Import',
    guide: 'Migration Guide',
    importTab: 'Import History',
    progressiveMigration: 'Progressive Migration',
    progressiveDesc: 'WeChat is the living room, Pengji is the bedroom — they can coexist. Migrate gradually from low to high risk.',
    taziStep: 'Buddy Meetups',
    taziDesc: 'Move meal, sports, and outing plans to Pengji',
    familyStep: 'Family Moments',
    familyDesc: 'Move kids photos and family stories to the family circle',
    bestieStep: 'Close Friends Chat',
    bestieDesc: 'Move private conversations with best friends to the close circle',
    lowRisk: 'Low',
    mediumRisk: 'Medium',
    highRisk: 'High',
    selectFile: 'Tap to select WeChat chat export file',
    fileFormats: 'Supports .txt .json .html .csv formats, max 200MB',
    parsing: 'Parsing...',
    parseComplete: 'Parse Complete',
    totalMessages: 'Total Messages',
    importable: 'Importable',
    skipped: 'Skipped',
    preview: 'Message Preview',
    confirmImport: 'Confirm Import',
    importSuccess: 'Chat history imported securely!',
    howToExport: 'How to export from WeChat',
    exportStep1: 'Open WeChat → enter the chat to export → tap top-right ···',
    exportStep2: 'Select "Chat History Migration & Backup"',
    exportStep3: 'Choose "Backup to Computer" or "Export Chat History"',
    exportStep4: 'Save the exported .txt or .json file to your phone',
    exportStep5: 'Return to Pengji, select file to import',
    securityNote: 'Security Guarantee After Import',
    securityDesc: 'Imported chat history is immediately E2EE encrypted. Servers cannot read content. You can delete imported data anytime.',
    coexistence: 'Not a replacement, but a complement. Pengji is your private space beyond WeChat.',
  },
  chat: {
    title: 'Chat',
    placeholder: 'Type a message...',
    circlePlaceholder: 'Message to circle...',
    emptyPrivate: 'Start your private conversation',
    emptyCircle: 'No messages yet, start chatting',
    typing: 'is typing...',
    online: 'Online',
    connecting: 'Connecting...',
    voiceCall: 'Voice Call',
    videoCall: 'Video Call',
    sendFile: 'Send File',
    voiceMsg: 'Voice Message',
    emoji: 'Emoji',
    send: 'Send',
    clearChat: 'Clear Chat',
    clearConfirm: 'Are you sure you want to clear all chat history? This cannot be undone.',
    uploadLimit: 'File size cannot exceed 100MB',
    uploadFailed: 'Upload failed',
    revoke: 'Revoke',
    revokeConfirm: 'Revoke this message? (within 2 minutes)',
    revoked: 'Message revoked',
  },
  messages: {
    title: 'Messages',
    noChats: 'No messages',
    noChatsHint: 'Add friends to start chatting',
    calls: 'Call History',
    noCalls: 'No call history',
    noCallsHint: 'Start an encrypted call with a friend',
    clearHistory: 'Clear Call History',
    groupChat: 'Group',
    privateChat: 'Private',
  },
  friends: {
    title: 'Friends',
    addFriend: 'Add Friend',
    myFriends: 'My Friends',
    noFriends: 'No friends yet',
    noFriendsHint: 'Tap the button above to add friends',
    pending: 'Pending Requests',
    accept: 'Accept',
    reject: 'Reject',
    remove: 'Remove',
    removeConfirm: 'Are you sure you want to remove this friend?',
    searchLabel: 'Friend username',
    searchPlaceholder: 'Enter username to search',
    search: 'Search',
    searching: 'Searching...',
    notFound: 'User not found, please verify the username',
    searchTip: 'Pengji only allows adding friends by exact username search. No stranger recommendations.',
    inviteLink: 'Or share invite link',
    copyInvite: 'Copy Invite Link',
    inviteCopied: 'Invite link copied',
    added: 'Friend added',
    removed: 'Friend removed',
  },
  profile: {
    title: 'Profile',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    e2ee: 'Encryption & Security',
    myKeys: 'My Encryption Keys',
    keyInfo: 'Private keys are stored only on your device, never leave it',
    watermark: 'Chat Watermark',
    watermarkOn: 'Watermark enabled',
    watermarkOff: 'Watermark disabled',
    dataSovereignty: 'Data Sovereignty',
    exportData: 'Export All My Data',
    exporting: 'Exporting...',
    exportHistory: 'Export History',
    noExports: 'No export history',
    deleteAccount: 'Delete Account Permanently',
    deleteWarning: 'This action cannot be undone!',
    invite: 'Invite Friends',
    widget: 'Desktop Widget',
    logout: 'Log Out',
    logoutConfirm: 'Are you sure you want to log out?',
    updated: 'Updated',
    bio: 'Bio',
    emptyBio: 'This person is lazy and wrote nothing',
  },
  login: {
    // Phone + SMS code sign-in was retired in Oct 2026 in favour of username + password.
    title: 'Sign in / Sign up',
    usernamePlaceholder: 'Username',
    passwordPlaceholder: 'Password',
    passwordAgainPlaceholder: 'Repeat password',
    nicknamePlaceholder: 'Display name (optional)',
    loginTab: 'Sign in',
    registerTab: 'Sign up',
    passwordTab: 'Password',
    login: 'Sign in',
    register: 'Create account',
    loggingIn: 'Signing in...',
    registering: 'Creating...',
    usernameHint: '4-20 characters: lowercase letters, digits or underscore, must include a letter',
    passwordHint: '8-64 characters, cannot be all digits',
    passwordMismatch: 'The two passwords do not match',
    forgot: 'Forgot password?',
    trustDevice: 'Sign in with device identity',
    agreement: 'By signing in, you agree to Pengji\'s privacy policy and terms',
    loginError: 'Sign-in failed, please try again',
    mustChangeTitle: 'Set a new password for your account',
    mustChangeBlurb: 'Your account was migrated from an older version and is still using a temporary password. For your security, please set a password only you know.',
    currentPasswordPlaceholder: 'Current password',
    newPasswordPlaceholder: 'New password',
    changePasswordSubmit: 'Save new password',
    changing: 'Saving...',
    recoveryTitle: 'Reset password',
    recoveryBlurb: 'Please contact support to reset your password. Leave your username and a way to reach you and we will verify your identity first.',
    recoveryContact: 'How to reach you (phone / WeChat)',
    recoveryNote: 'Additional notes (optional)',
    recoverySubmit: 'Submit request',
    recoverySubmitting: 'Submitting...',
    recoveryDone: 'Request submitted',
    recoveryDoneBlurb: 'Support will contact you to verify your identity and then reset your password.',
  },
  e2ee: {
    active: 'End-to-End Encrypted',
    waiting: 'Awaiting key exchange',
    encrypted: 'E2EE Encrypted',
    secure: 'Messages are end-to-end encrypted',
    safeTransport: 'Messages are securely transported',
    callEncrypted: 'Call Encrypted',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    loading: 'Loading...',
    noData: 'No data',
    back: 'Back',
    online: 'Online',
    members: 'members',
    membersInOnline: 'online',
  },
  burn: { title: 'Burn After Read', burned: 'Message burned' },
  call: {
    incoming: 'invites you to a video call',
    incomingAudio: 'invites you to a voice call',
    incomingScreen: 'invites you to screen share',
    calling: 'Calling...',
    accept: 'Accept',
    reject: 'Reject',
    hangup: 'Hang Up',
    mute: 'Mute',
    unmute: 'Unmute',
    speaker: 'Speaker',
    camera: 'Camera',
  },
  circle: {
    title: 'Circle Details',
    notFound: 'Circle not found',
    members: 'Circle Members',
    owner: 'Owner',
    admin: 'Admin',
    member: 'Member',
    remove: 'Remove',
    removeConfirm: 'Are you sure you want to remove this member?',
    removed: 'Member removed',
    deleteCircle: 'Delete Circle',
    dangerZone: 'Danger Zone',
    noDesc: 'No description',
  },
  polls: {
    title: 'Polls',
    createPoll: 'Create Poll',
    noPolls: 'No polls yet',
    noPollsHint: 'Create a poll to decide dinner, movies, or places together',
    pollTitle: 'Poll Title',
    options: 'Options',
    addOption: 'Add Option',
    allowMultiple: 'Allow Multiple',
    create: 'Create',
    created: 'Poll created',
    closed: 'Poll closed',
    active: 'Active',
    single: 'Single',
    multi: 'Multi',
    voted: 'Vote submitted',
    voters: 'Voters',
    closePoll: 'Close Poll',
    fillAll: 'Please fill in all fields',
  },
  moments: {
    title: 'Circle Moments',
    noMoments: 'No moments yet',
    noMomentsHint: 'Post the first circle moment',
    post: 'Post',
    posting: 'Posting...',
    publish: 'Publish Moment',
    compose: 'New Moment',
    placeholder: 'Share your thoughts...',
    anonymous: 'Anonymous',
    anonymousOn: 'Anonymous',
    screenshotProtect: 'Screenshot Protect',
    screenshotOn: 'Protected',
    permanent: 'Permanent',
    burn1h: 'Burn after 1 hour',
    burn24h: 'Burn after 24 hours',
    burn72h: 'Burn after 3 days',
    posted: 'Posted successfully',
  },
  sharedList: {
    title: 'Shared Lists',
    newList: 'New',
    noLists: 'No shared lists',
    noListsHint: 'Create a list and collaborate with circle friends',
    listName: 'List Name',
    listType: 'List Type',
    create: 'Create',
    created: 'List created',
    deleted: 'List deleted',
    deleteConfirm: 'Are you sure you want to delete this list?',
    addItem: 'Add new item...',
    add: 'Add',
    noItems: 'No items yet, add the first one',
    creator: 'Creator',
    archived: 'Archived',
    deleteItem: 'Delete this list',
    checklist: 'Checklist',
    shopping: 'Shopping',
    travel: 'Travel',
    bill: 'Bill Split',
    care: 'Care',
  },
  widget: {
    title: 'Desktop Widget',
    subtitle: 'Lightweight interaction · push to friends\' home screen',
    pushWidget: 'Push Widget',
    pushHint: 'Take a photo or write a note, push it to your friend\'s home screen',
    selectFriend: 'Select a friend and send',
    toFriend: 'Send something to your friend...',
    send: 'Send',
    sending: 'Sending...',
    cancel: 'Cancel',
    noFriends: 'No friends yet, add friends first',
    received: 'Received Widgets',
    noReceived: 'No widgets received',
    sent: 'Sent Widgets',
    noSent: 'No sent history',
    sentTo: 'Sent to',
    pushed: 'Widget pushed!',
  },
  decentralized: {
    title: 'Decentralized Hub',
    ipfs: 'IPFS Storage',
    federation: 'Federation',
    matrix: 'Matrix Bridge',
    nodeStatus: 'Node Status',
    running: 'Running',
    offline: 'Offline',
    peerId: 'Peer ID',
    peerCount: 'Connected Peers',
    storagePath: 'Storage Path',
    uploading: 'Uploading...',
    uploadToIPFS: 'Upload to IPFS',
    uploadHint: 'Click or drag files here',
    maxSize: 'Max 100MB',
    textAttestation: 'Text Attestation',
    attestPlaceholder: 'Enter text to attest...',
    attestUpload: 'Upload to Chain',
    uploaded: 'Upload successful',
    uploadFailed: 'IPFS upload failed',
    localNode: 'Local Node',
    serverName: 'Server Name',
    serverId: 'Server ID',
    knownNodes: 'Known Nodes',
    fedNodes: 'Federation Nodes',
    noFedNodes: 'No known federation nodes',
    addNode: 'Add Node',
    connect: 'Connect',
    crossSearch: 'Cross-server Search',
    searchPlaceholder: 'Username or @user:server',
    search: 'Search',
    noResults: 'No users found',
    sendMessage: 'Send Message',
    matrixComing: 'Matrix Bridge Coming Soon',
    matrixDesc: 'Through the Matrix protocol, Pengji will interconnect with the global decentralized communication network.',
    plannedFeatures: 'Planned Features',
  },
  invite: {
    title: 'Invite Friends',
    myCode: 'My Invite Code',
    copyLink: 'Copy Invite Link',
    copied: 'Invite link copied to clipboard',
    shareWechat: 'Share to WeChat friends or groups',
    unlockTitle: 'Invite friends to unlock more features',
    howToUse: 'How It Works',
    step1: 'Copy invite code or share link with friends',
    step2: 'Friends download Pengji and enter your invite code',
    step3: 'Both become friends automatically, unlocking circle features',
  },
};
